import { Button } from "react-daisyui";
import { useRouteError } from "react-router-dom";
import { ErrorScreen } from "./ErrorScreen";

/**
 * Screens are loaded in pieces as they are opened, and Hosting only serves the
 * current release. A tab left open across a release therefore asks for a piece
 * that is no longer there, which reads as a broken screen but is only a stale
 * tab. Reloading is the one thing that fixes it, so say so and offer it.
 */
const isStaleBuildError = (error: unknown) =>
    error instanceof Error &&
    /dynamically imported module|Importing a module script failed|ChunkLoadError/i.test(
        `${error.name} ${error.message}`
    );

interface Props {
    title?: string;
    message?: string;
}

export const RouteErrorScreen = ({ title, message }: Props) => {
    const error = useRouteError();

    if (isStaleBuildError(error)) {
        return (
            <ErrorScreen
                title="Hub has been updated"
                message="This screen belongs to a newer version of Hub. Reload to carry on."
                action={
                    <Button type="button" color="primary" onClick={() => window.location.reload()}>
                        Reload Hub
                    </Button>
                }
            />
        );
    }

    return (
        <ErrorScreen
            title={title ?? "Something went wrong"}
            message={message ?? "Something happened that we couldn't recover from."}
            errorObj={error instanceof Error ? error : undefined}
            action={
                <Button type="button" color="primary" onClick={() => window.location.reload()}>
                    Reload Hub
                </Button>
            }
        />
    );
};
